// Events
export const AHOC_APPLICATION_REQUEST =
  "allsureHomeClaim/policyRequest/";

export const SEND_CLAIM_SUBMISSION_MAIL=AHOC_APPLICATION_REQUEST+'claimSubmissionMail'
export const submitPolicy = () => ({  
  type: SEND_CLAIM_SUBMISSION_MAIL,
}); 
export const SEND_DOCUMENTS=AHOC_APPLICATION_REQUEST+'uploadDocuments'

 export const uploadDocumentsRequest=()=>({
type:SEND_DOCUMENTS,
})